import React, { useState, useEffect } from 'react';
import { MdEdit } from "react-icons/md";
import Modal from 'react-bootstrap/Modal';
import { BASEAPIURL, token } from '../../env';

export default function Reservation() {
    const [schemes, setSchemes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [showAdd, setShowAdd] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [selectedScheme, setSelectedScheme] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const initialForm = {
        SchemeTitle: '',
        SchemeDesc: '',
        SchemeImages: '',
        SchemeFromDate: '',
        SchemeToDate: '',
        SchemeDeActive: false,
        SchemeRate: 0,
        SchemeDisRate: 0,
        SchemeQty: 0,
        SchemeFreeQty: 0,
        SchemeUnit: '',
    };
    const [form, setForm] = useState(initialForm);

    useEffect(() => {
        fetchSchemes();
    }, []);

    const fetchSchemes = () => {
        setLoading(true);
        setError(null);

        const myHeaders = new Headers({ "Content-Type": "application/json" });
        const raw = JSON.stringify({ tokenData: token });

        fetch(`${BASEAPIURL}/SchemeList`, {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        })
            .then(async response => {
                const text = await response.text();
                try {
                    return JSON.parse(text);
                } catch (err) {
                    throw new Error("Invalid JSON: " + err.message);
                }
            })
            .then(result => {
                if (Array.isArray(result?.data)) {
                    setSchemes(result.data);
                } else {
                    setSchemes([]);
                }
            })
            .catch(error => {
                console.error("API Error:", error);
                setError("Failed to fetch schemes.");
                setSchemes([]);
            })
            .finally(() => setLoading(false));
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const openAddModal = () => {
        setForm(initialForm);
        setShowAdd(true);
    };

    const openEditModal = (scheme) => {
        setSelectedScheme(scheme);
        const fromDate = scheme.SchemeFromDate ? scheme.SchemeFromDate.split('T')[0] : '';
        const toDate = scheme.SchemeToDate ? scheme.SchemeToDate.split('T')[0] : '';
        setForm({
            ...scheme,
            SchemeFromDate: fromDate,
            SchemeToDate: toDate,
        });
        setShowEdit(true);
    };

    const handleAddSubmit = (e) => {
        e.preventDefault();

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const bodyData = {
            tokenData: token,
            Sche: {
                ...form,
                SchemeFromDate: form.SchemeFromDate + " 00:00:00:000",
                SchemeToDate: form.SchemeToDate + " 23:59:59:000",
                SchemeRate: Number(form.SchemeRate),
                SchemeDisRate: Number(form.SchemeDisRate),
                SchemeQty: Number(form.SchemeQty),
                SchemeFreeQty: Number(form.SchemeFreeQty),
                SchemeDeActive: !!form.SchemeDeActive,
            }
        };

        fetch(`${BASEAPIURL}/InsertScheme`, {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(bodyData),
            redirect: "follow"
        })
            .then(response => response.json())
            .then(() => {
                alert("Scheme added successfully");
                setShowAdd(false);
                fetchSchemes();
            })
            .catch(error => {
                console.error(error);
                alert("Failed to add scheme");
            });
    };

    const handleEditSubmit = (e) => {
        e.preventDefault();
        if (!selectedScheme) return;

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const bodyData = {
            tokenData: token,
            Sche: {
                SchemeTitle: form.SchemeTitle,
                SchemeDesc: form.SchemeDesc,
                SchemeFromDate: form.SchemeFromDate + "T00:00:00",
                SchemeToDate: form.SchemeToDate + "T23:59:59",
                SchemeDeActive: !!form.SchemeDeActive,
                SchemeImages: form.SchemeImages || "",
                SchemeRate: Number(form.SchemeRate),
                SchemeDisRate: Number(form.SchemeDisRate),
                SchemeQty: Number(form.SchemeQty),
                SchemeFreeQty: Number(form.SchemeFreeQty),
                SchemeUnit: form.SchemeUnit || "",
            }
        };

        fetch(`${BASEAPIURL}/UpdateScheme?MainID=${selectedScheme.SchemeID}`, {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(bodyData),
            redirect: "follow"
        })
            .then(response => response.json())
            .then(() => {
                alert("Scheme updated successfully");
                setShowEdit(false);
                fetchSchemes();
            })
            .catch(error => {
                console.error(error);
                alert("Failed to update scheme");
            });
    };

    const filteredSchemes = schemes.filter(s =>
        s.SchemeTitle?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <div className='row d-flex justify-content-between align-items-center mb-2 g-0 py-2'>
                <div className='col-4'>
                    <input
                        type="text"
                        placeholder="Search by title"
                        className="form-control form-control-sm"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <div onClick={openAddModal} className='col-2 d-flex justify-content-center align-items-center p-2 rounded-1' style={{ backgroundColor: "#000", fontWeight: 400, color: "#fff", cursor: "pointer" }}>
                    + Add
                </div>
            </div>

            <div className="table-responsive">
                {loading && <div>Loading schemes...</div>}
                {error && <div className="text-danger">{error}</div>}
                {!loading && !error && (
                    <table className="table table-striped table-bordered table-sm align-middle ">
                        <thead className="table-dark">
                            <tr>
                                <th>S.No.</th>
                                <th>Scheme Title</th>
                                <th>Scheme Description</th>
                                <th>From Date</th>
                                <th>To Date</th>
                                <th>Rate</th>
                                <th>Discount Rate</th>
                                <th>Qty</th>
                                <th>Free Qty</th>
                                <th>DeActive</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredSchemes.length > 0 ? (
                                filteredSchemes.map((scheme, index) => (
                                    <tr key={scheme.SchemeID}>
                                        <td>{index + 1}</td>
                                        <td>{scheme.SchemeTitle}</td>
                                        <td>{scheme.SchemeDesc}</td>
                                        <td>{scheme.SchemeFromDate?.split('T')[0]}</td>
                                        <td>{scheme.SchemeToDate?.split('T')[0]}</td>
                                        <td>{scheme.SchemeRate}</td>
                                        <td>{scheme.SchemeDisRate}</td>
                                        <td>{scheme.SchemeQty}</td>
                                        <td>{scheme.SchemeFreeQty}</td>
                                        <td>{scheme.SchemeDeActive ? "Yes" : "No"}</td>
                                        <td>
                                            <div className='d-flex justify-content-center gap-2'>
                                                <MdEdit
                                                    style={{ cursor: "pointer", color: "blue" }}
                                                    onClick={() => openEditModal(scheme)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={11} className="text-center">No schemes found</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={11} className="text-center text-muted">
                                    {loading ? "Connecting to API..." :
                                        error ? "API error occurred." :
                                            `Showing ${filteredSchemes.length} scheme(s)`}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                )}
            </div>

            <Modal show={showAdd} onHide={() => setShowAdd(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Add Scheme</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleAddSubmit}>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label">Scheme Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="SchemeTitle"
                                    value={form.SchemeTitle}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Scheme Description</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="SchemeDesc"
                                    value={form.SchemeDesc}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">From Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="SchemeFromDate"
                                    value={form.SchemeFromDate}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">To Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="SchemeToDate"
                                    value={form.SchemeToDate}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Rate</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="SchemeRate"
                                    value={form.SchemeRate}
                                    onChange={handleInputChange}
                                    min="0"
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Discount Rate</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="SchemeDisRate"
                                    value={form.SchemeDisRate}
                                    onChange={handleInputChange}
                                    min="0"
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Quantity</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="SchemeQty"
                                    value={form.SchemeQty}
                                    onChange={handleInputChange}
                                    min="0"
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Free Quantity</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="SchemeFreeQty"
                                    value={form.SchemeFreeQty}
                                    onChange={handleInputChange}
                                    min="0"
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Unit</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="SchemeUnit"
                                    value={form.SchemeUnit}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="col-md-4 d-flex align-items-center">
                                <label className="form-label me-2">DeActive</label>
                                <input
                                    type="checkbox"
                                    name="SchemeDeActive"
                                    checked={form.SchemeDeActive}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>

                        <div className="mt-3 d-flex justify-content-end">
                            <button type="button" className="btn btn-secondary me-2" onClick={() => setShowAdd(false)}>Cancel</button>
                            <button type="submit" className="btn btn-primary">Save</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            {/* Edit Scheme Modal */}
            <Modal show={showEdit} onHide={() => setShowEdit(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Scheme</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleEditSubmit}>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label">Scheme Title</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="SchemeTitle"
                                    value={form.SchemeTitle}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Scheme Description</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="SchemeDesc"
                                    value={form.SchemeDesc}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">From Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="SchemeFromDate"
                                    value={form.SchemeFromDate}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">To Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="SchemeToDate"
                                    value={form.SchemeToDate}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Rate</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="SchemeRate"
                                    value={form.SchemeRate}
                                    onChange={handleInputChange}
                                    min="0"
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Discount Rate</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="SchemeDisRate"
                                    value={form.SchemeDisRate}
                                    onChange={handleInputChange}
                                    min="0"
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Quantity</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="SchemeQty"
                                    value={form.SchemeQty}
                                    onChange={handleInputChange}
                                    min="0"
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Free Quantity</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="SchemeFreeQty"
                                    value={form.SchemeFreeQty}
                                    onChange={handleInputChange}
                                    min="0"
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Unit</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="SchemeUnit"
                                    value={form.SchemeUnit}
                                    onChange={handleInputChange}
                                />
                            </div>

                            <div className="col-md-4 d-flex align-items-center">
                                <label className="form-label me-2">DeActive</label>
                                <input
                                    type="checkbox"
                                    name="SchemeDeActive"
                                    checked={form.SchemeDeActive}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>

                        <div className="mt-3 d-flex justify-content-end">
                            <button type="button" className="btn btn-secondary me-2" onClick={() => setShowEdit(false)}>Cancel</button>
                            <button type="submit" className="btn btn-primary">Update</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>


        </>
    );
}
